const PAGE_CONSTANTS = {
 YOUR_APPOINTMENT_CONFIRMED_TITLE: "Your appointment request has been submitted.",
 SERVICE_UNAVAILABLE_TEXT: "Service unavailable for this location. Please try with another pincode",
 APPLICATION_TRACKER:"Application Tracker",
 MEDICAL_APPOINTMENT_BOOKING: "Medical Appointment Booking",
 HOME_VISIT_TYPE: "HOME",
 DIAGNOSTIC_CENTER_TYPE: "DC",
 ALLOWED_MAX_TIMING_FIVE_PM: "5:00 PM",
 ALLOWED_TIMING_ELEVEN_AM: "11:00 AM",
 TPA_HA: "HA",
 TPA_HI: "HI",
 TPA_VH: "VH",
 TPA_MG: "MAGGNESSA",
 MERIDIEM_AM: "AM",
 MERIDIEM_PM: "PM",
 TIME_CONFIG: {
    AM: ["07","08","09","10","11"],
    PM: ["12","01","02","03","04","05"]
 },
 PRIORITY_INDEX: {
   FIRST: 0,
   SECOND: 1,
   THIRD: 2,
 }
}

export default PAGE_CONSTANTS;